/**
 * Mode Select (Screen 2) — v0M3.7.
 *
 * Two tiles per Michael's spec: Standard and Fantasy (placeholder). Back
 * link returns to Main Menu.
 */

import type { MenuState } from './menu-state';

export interface ModeSelectCallbacks {
  onStandard: () => void;
  onFantasy: () => void;
  onBack: () => void;
}

export function renderModeSelect(
  panel: HTMLElement,
  state: MenuState,
  cb: ModeSelectCallbacks,
): void {
  const back = document.createElement('button');
  back.className = 'su-menu-back';
  back.textContent = '← Back';
  back.addEventListener('click', cb.onBack);
  panel.appendChild(back);

  const h = document.createElement('h2');
  h.className = 'su-menu-title';
  h.textContent = 'New Game';
  panel.appendChild(h);

  if (state.banner !== null) {
    const banner = document.createElement('div');
    banner.className = 'su-menu-banner';
    banner.textContent = state.banner;
    panel.appendChild(banner);
  }

  const row = document.createElement('div');
  row.className = 'su-menu-mode-tile-row';
  panel.appendChild(row);

  row.appendChild(
    makeTile({
      title: 'Standard',
      desc: 'Classical Antiquity — 6 human factions on the Karth map.',
      disabled: false,
      onClick: cb.onStandard,
    }),
  );
  row.appendChild(
    makeTile({
      title: 'Fantasy',
      desc: 'Coming soon — elves, dwarves, dragons.',
      disabled: true,
      onClick: cb.onFantasy,
    }),
  );
}

function makeTile(args: {
  title: string;
  desc: string;
  disabled: boolean;
  onClick: () => void;
}): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.className = args.disabled ? 'su-menu-mode-tile su-disabled' : 'su-menu-mode-tile';
  const title = document.createElement('div');
  title.className = 'su-menu-mode-tile-title';
  title.textContent = args.title;
  btn.appendChild(title);
  const desc = document.createElement('div');
  desc.className = 'su-menu-mode-tile-desc';
  desc.textContent = args.desc;
  btn.appendChild(desc);
  btn.addEventListener('click', args.onClick);
  return btn;
}
